/* It's an aboject containing a function that takes a string as a parameter and returns an object. */
const fieldIcons = {
    /* A function that takes a string as a parameter and returns an object. */
    getIcon: (type: string) => {
        const icon = fieldIcons.icons.find(obj => {
            return obj.type === type
        })
        return icon
    },
    icons: [
        {
            type: "Number",
            icon: "pin"
        },
        {
            type: "Text",
            icon: "text_format"
        },
        {
            type: "Drop Down",
            icon: "format_list_bulleted_add"
        },
        {
            type: "MultiSelect",
            icon: "format_list_bulleted_add",
            text: "*n"
        },
        {
            type: "Signature",
            icon: "draw"
        },
        {
            type: "Date",
            icon: "event"
        },
        {
            type: "StaticText",
            icon: "article"
        },
        {
            type: "Section",
            icon: "minimize"
        },
        {
            type: "Yes or No",
            icon: "toggle_off"
        },
        {
            type: "Time",
            icon: "watch"
        },
        {
            type: "Comments",
            icon: "chat"
        },
        {
            type: "Scanner",
            icon: "qr_code_scanner"
        },
        {
            type: "ImageSketch",
            icon: "draw"
        },
        {
            type: "SamsaraS3Video",
            icon: "personal_video"
        }
    ]
}

export default fieldIcons